// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { MFAOptions } from '@innolab-trader/tradovate-types'
import type { HibpHint } from '@innolab-trader/tradovate-types/src/enums/hibpHint'
import type { UserExperience } from '@innolab-trader/tradovate-types/src/enums/userExperience'
import type { UserStatus } from '@innolab-trader/tradovate-types/src/enums/userStatus'

export interface RenewAccessToken {

}

export interface AccessTokenResponse {
  errorText?: string
  hibpHint?: HibpHint
  accessToken?: string
  mdAccessToken?: string
  expirationTime?: string
  passwordExpirationTime?: string
  userStatus?: UserStatus
  userId?: number
  name?: string
  hasLive?: boolean
  hasSimPlus?: boolean
  outdatedTaC?: boolean
  hasFunded?: boolean
  hasMarketData?: boolean
  requiredNonProCertification?: boolean
  newTrialEligible?: boolean
  outdatedLiquidationPolicy?: boolean
  outdatedSentimentPolicy?: boolean
  mfa?: MFAOptions
  experience?: UserExperience
  orgName?: string
}

/**
 * Validate RenewAccessToken request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param _request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateRenewAccessToken(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateRenewAccessToken(_request: RenewAccessToken): ValidationError[] {
  const errors: ValidationError[] = []



  return errors
}

export const renewAccessToken = postEndpoint<RenewAccessToken, AccessTokenResponse>('/auth/renewAccessToken')
